exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-modal .uk-modal-dialog[data-v-febbb9de] {\n  width: 800px;\n}", ""]);

// exports
